export const COMPLAN = 'http://webtrans.yodao.com/server/webtrans/report'
export const WEBSHAREPAGE = 'http://webtrans.yodao.com/server/webtrans/tranUrl'